var BooleanItemMode = /* @__PURE__ */ ((BooleanItemMode2) => {
  BooleanItemMode2[BooleanItemMode2["Switch"] = 0] = "Switch";
  BooleanItemMode2[BooleanItemMode2["Toggle"] = 1] = "Toggle";
  return BooleanItemMode2;
})(BooleanItemMode || {});
export {
  BooleanItemMode as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQm9vbGVhbkl0ZW1Nb2RlLmpzIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdHlwZXMvZW51bXMvQm9vbGVhbkl0ZW1Nb2RlLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImVudW0gQm9vbGVhbkl0ZW1Nb2RlIHtcbiAgICBTd2l0Y2gsXG4gICAgVG9nZ2xlXG59XG5cbmV4cG9ydCBkZWZhdWx0IEJvb2xlYW5JdGVtTW9kZTsiXSwibmFtZXMiOlsiQm9vbGVhbkl0ZW1Nb2RlIl0sIm1hcHBpbmdzIjoiQUFBSyxJQUFBLG9DQUFBQSxxQkFBTDtBQUNJQSxtQkFBQSxpQkFBQSxRQUFBLElBQUEsQ0FBQSxJQUFBO0FBQ0FBLG1CQUFBLGlCQUFBLFFBQUEsSUFBQSxDQUFBLElBQUE7QUFGQ0EsU0FBQUE7QUFBQSxHQUFBLG1CQUFBLENBQUEsQ0FBQTsifQ==
